/**
 * WarehouseSelector - Component for selecting a single warehouse
 */
import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useWarehouse } from '../../contexts/WarehouseContext';
import { getTextFieldStyles, getAutocompleteStyles, getAutocompleteListboxStyles } from '../../styles/formStyles';

interface WarehouseSelectorProps {
  value: number | null;
  onChange: (warehouseId: number | null) => void;
  disabled?: boolean;
  placeholder?: string;
  label?: string;
  error?: boolean;
  helperText?: string;
  required?: boolean;
}

const WarehouseSelector: React.FC<WarehouseSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  placeholder = '',
  label,
  error = false,
  helperText,
  required = false,
}) => {
  const { warehouses, loading } = useWarehouse();

  const selectedWarehouse = warehouses.find((w) => w.id === value) || null;

  const handleChange = (_event: any, newValue: typeof selectedWarehouse) => {
    onChange(newValue ? newValue.id : null);
  };

  return (
    <Autocomplete
      options={warehouses}
      value={selectedWarehouse}
      onChange={handleChange}
      disabled={disabled || loading}
      loading={loading}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          required={required}
          fullWidth
          margin="normal"
          sx={getTextFieldStyles({ error })}
        />
      )}
      fullWidth
      sx={getAutocompleteStyles()}
      ListboxProps={{
        sx: getAutocompleteListboxStyles(),
      }}
    />
  );
};

export default WarehouseSelector;
